import { render, staticRenderFns } from "./FacilityEditTabInfo.vue?vue&type=template&id=d185940a&"
import script from "./FacilityEditTabInfo.vue?vue&type=script&lang=js&"
export * from "./FacilityEditTabInfo.vue?vue&type=script&lang=js&"
import style0 from "./FacilityEditTabInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports